import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  Card,
  Modal,
  TextField,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Switch,
  Box,
  Select,
  MenuItem,
  IconButton,
  RadioGroup,
  Radio,
  FormControl,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TablePagination,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CancelButton from 'src/components/shared/CancelButton';
import CompleteButton from 'src/components/shared/CompleteButton';
import MultipleImageUpload from 'src/components/shared/MultipleImageUpload';
import Services from 'src/services/Services';
import moment from 'moment';
import { toast } from 'react-toastify';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './AddEditBolParaCompany.css'
import { useLocalization } from 'src/context/LocalizationContext';
import FormCreator from './FormCreator';
import { GridDeleteIcon } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit } from '@mui/icons-material';
import api from 'src/services/BaseService';

export default function AddEditCampaignModal({ open, onClose, getCampaigns, campaign, setSelectedCampaign }) {
  const { language } = useLocalization();
  const parsedUser = JSON.parse(localStorage.getItem('user'));

  const [campaignTitle, setCampaignTitle] = useState("");
  const [campaignImages, setCampaignImages] = useState([]);
  const [campaignStart, setCampaignStart] = useState();
  const [campaignEnd, setCampaignEnd] = useState();
  const [campaignLink, setCampaignLink] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [selectedCategories, setSelectedCategories] = useState({
    esnaf: false,
    easypoint: false,
    personalCustomers: false,
  });
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ——— Form builder alanları ———
  const [forms, setForms] = useState([]);
  const [applyWithForm, setApplyWithForm] = useState(false);
  const [selectedFormId, setSelectedFormId] = useState('');
  const [showFormCreator, setShowFormCreator] = useState(false);
  const [previewForm, setPreviewForm] = useState(null);
  const [editingForm, setEditingForm] = useState(null);
  const [newlyAddedForms, setNewlyAddedForms] = useState([]);

  // ——— BolPara NOKTALAR filtresi için eklenen state'ler (birebir) ———
  const [showPoints, setShowPoints] = useState(false);
  const [allPoints, setAllPoints] = useState([]);
  const [pointsData, setPointsData] = useState([]);
  const [selectedPoints, setSelectedPoints] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [pointsFilters, setPointsFilters] = useState({
    isAmazon: false,
    isArasKargo: false,
    isEasyPoint: true,
    isEsnaf: true,
    isHepsiburada: false,
    isHepsijet: false,
    isMalKabul: false,
    isMuhaberat: false,
    isN11: false,
    isSuratkargo: false,
    isTrendyol: false,
    status: '1',
    city: '',
    district: '',
    searchText: '',
    isCorporational: '0'
  });
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);

  // ——— NOKTALAR: handler'lar (birebir) ———
  const handleSearchChange = (e) => {
    const { value } = e.target;
    setPointsFilters(prev => ({ ...prev, searchText: value }));
  };
  const handleCorporationalChange = (e) => {
    setPointsFilters(prev => ({ ...prev, isCorporational: e.target.value }));
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setPointsFilters(prev => ({ ...prev, [name]: checked }));
  };
  const handleRadioChange = (e) => {
    setPointsFilters(prev => ({ ...prev, status: e.target.value }));
  };
  const handleCityChange = (e) => {
    const cityCode = e.target.value;
    setPointsFilters(prev => ({ ...prev, city: cityCode, district: '' }));
    setDistricts([]);
    if (cityCode) fetchTowns(cityCode);
  };
  const handleDistrictChange = (e) => {
    setPointsFilters(prev => ({ ...prev, district: e.target.value }));
  };
  const handleSelectPoint = (id) => {
    setSelectedPoints(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const handleSelectAll = (checked) => {
    if (checked) setSelectedPoints(pointsData.map(p => p.id)); else setSelectedPoints([]);
  };

  // ——— NOKTALAR: servisler (birebir) ———
  const fetchCities = () => {
    Services.GetCities(parsedUser.token)
      .then(res => {
        if (res.data.status) setCities(res.data.result); else toast.error('İl listesi alınamadı');
      })
      .catch(err => console.log(err));
  };

  const fetchTowns = (cityCode) => {
    Services.GetTowns(parsedUser.token, cityCode)
      .then(res => {
        if (res.data.status) setDistricts(res.data.result); else toast.error('İlçe listesi alınamadı');
      })
      .catch(err => console.log(err));
  };

  function fetchAllPoints() {
    api
      .post('flow/get-points')
      .then((response) => {
        if (response.data.status) {
          const result = response.data.result;
          setAllPoints(result);
          applyFilters(result);
        } else {
          toast.error('Noktalar yüklenemedi');
        }
      })
      .catch((error) => toast.error(error.message));
  }

  function applyFilters(data, forcedSelected = null) {
    const toKeep = forcedSelected ?? selectedPoints;
    let filtered = data;

    // 0) Başlık filtresi
    if (pointsFilters.searchText) {
      const term = pointsFilters.searchText.toLocaleLowerCase('tr-TR').trim();
      filtered = filtered.filter(item => item.title?.toLocaleLowerCase('tr-TR').includes(term));
    }

    // 1) Checkbox'lar OR
    const activeBoxes = Object.entries(pointsFilters)
      .filter(([key, val]) => key.startsWith('is') && val)
      .map(([key]) => key);
    if (activeBoxes.length) {
      filtered = filtered.filter(item => activeBoxes.some(key => String(item[key]) === '1'));
    }

    // 2) Status
    filtered = filtered.filter(item => String(item.status) === pointsFilters.status);

    // 3) Şehir
    if (pointsFilters.city) {
      const cityObj = cities.find(c => c.code === pointsFilters.city);
      const cityName = cityObj?.name || '';
      filtered = filtered.filter(item => item.city?.toLocaleLowerCase('tr-TR') === cityName.toLocaleLowerCase('tr-TR'));
    }

    // 4) İlçe
    if (pointsFilters.district) {
      const distObj = districts.find(d => d.code === pointsFilters.district);
      const distName = distObj?.name || '';
      filtered = filtered.filter(item => item.district?.toLocaleLowerCase('tr-TR') === distName.toLocaleLowerCase('tr-TR'));
    }

    // 5) Zorunlu seçilenleri başa al
    if (toKeep.length) {
      const forcedItems = toKeep.map(id => data.find(item => item.id === id)).filter(Boolean);
      const forcedSet = new Set(toKeep);
      const otherItems = filtered.filter(item => !forcedSet.has(item.id));
      filtered = [...forcedItems, ...otherItems];
    }

    // 6) Kurumsal
    if (pointsFilters.isCorporational !== '') {
      filtered = filtered.filter(item => String(item.isCorporational) === pointsFilters.isCorporational);
    }

    setPointsData(filtered);
  }

  // ——— Kategori handler ———
  const handleCategoryChange = (event) => {
    setSelectedCategories({ ...selectedCategories, [event.target.name]: event.target.checked });
  };

  const handleSwitchApply = () => {
    setApplyWithForm(prev => !prev);
    if (applyWithForm) setSelectedFormId('');
  };

  const openCreatorForNew = () => { setEditingForm(null); setShowFormCreator(true); };
  const openCreatorForEdit = () => {
    const form = forms.find(f => f.id === selectedFormId);
    if (form) { setEditingForm(form); setShowFormCreator(true); }
  };

  const onFormSave = formData => {
    const safeFormData = { ...formData, id: formData.id || Date.now().toString(), ...(formData.formID ? { formID: formData.formID } : {}) };
    setForms(prev => {
      const exists = prev.find(f => f.id === safeFormData.id);
      return exists ? prev.map(f => f.id === safeFormData.id ? safeFormData : f) : [...prev, safeFormData];
    });
    setNewlyAddedForms(prev => {
      const alreadyExists = prev.find(f => f.id === safeFormData.id);
      return alreadyExists ? prev.map(f => f.id === safeFormData.id ? safeFormData : f) : [...prev, safeFormData];
    });
    setSelectedFormId(safeFormData.id);
    setShowFormCreator(false);
    setEditingForm(null);
  };

  const removeForm = (formID) => {
    Services.RemoveCampaignForm(parsedUser.token, formID)
      .then((res) => { if (res.data.status) toast.success("Form başarıyla silindi."); else toast.error("Form silinirken bir hata oluştu."); })
      .catch((err) => console.log(err));
  }

  const handleFormDelete = (id) => {
    removeForm(id);
    setForms(prev => prev.filter(f => f.formID !== id));
    if (selectedFormId === id) setSelectedFormId(null);
  };

  const allFieldsAreValid = () => {
    let isEmpty = true
    const isAtLeastOneCategorySelected = Object.values(selectedCategories).some(v => v === true);
    if (editorState) isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(b => b.text.trim() === "");
    return !!(campaignTitle && !isEmpty && campaignStart && campaignEnd && isAtLeastOneCategorySelected);
  }

  // ——— Edit modunda değerleri doldur ve NOKTALAR'ı kampanyadan al ———
  useEffect(() => {
    if (campaign) {
      setCampaignTitle(campaign.title);
      setCampaignImages(campaign.images);
      setCampaignStart(moment(campaign.start * 1000));
      setCampaignEnd(moment(campaign.end * 1000));
      setCampaignLink(campaign.link);
      const contentBlock = htmlToDraft(campaign.description);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      setEditorState(EditorState.createWithContent(contentState));
      setApplyWithForm(campaign.hasForm === "1");
      setSelectedFormId(campaign.selectedFormID);
      setIsActive(campaign.status === "1");
      if (campaign.targetAudience) {
        const updated = {
          esnaf: campaign.targetAudience.includes('esnaf'),
          easypoint: campaign.targetAudience.includes('easypoint'),
          personalCustomers: campaign.targetAudience.includes('personal-customers'),
        };
        setSelectedCategories(updated);
      }
      // Allowed points varsa önce onları set et ve filtreyi onlara göre uygula
      const preselected = campaign.allowedPoints || [];
      setSelectedPoints(preselected);
      if (allPoints.length) applyFilters(allPoints, preselected);
      getCampaignForms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign]);

  // NOKTALAR paneli açıldığında dataları çek
  useEffect(() => {
    if (showPoints) {
      fetchAllPoints();
      fetchCities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPoints]);

  const categoryMapping = { esnaf: 'esnaf', easypoint: 'easypoint', personalCustomers: 'personal-customers' };
  const getSelectedCategoriesArray = () => Object.keys(selectedCategories).filter(k => selectedCategories[k]).map(k => categoryMapping[k]);

  const formattedDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const extractBase64Images = (data) => data.map(item => item.base64.base64);

  const handleOnClose = () => {
    onClose();
    setCampaignTitle("");
    setCampaignImages([]);
    setCampaignStart();
    setCampaignEnd();
    setCampaignLink("");
    setEditorState(EditorState.createEmpty());
    setSelectedCampaign();
    setSelectedCategories({ esnaf: false, easypoint: false, personalCustomers: false });
    setIsActive(false);
    setForms([]);
    setApplyWithForm(false);
    setSelectedFormId('');
    setShowFormCreator(false);
    setPreviewForm(null);
    setNewlyAddedForms([]);
    // NOKTALAR reset
    setShowPoints(false);
    setSelectedPoints([]);
    setPointsFilters({
      isAmazon: false, isArasKargo: false, isEasyPoint: true, isEsnaf: true,
      isHepsiburada: false, isHepsijet: false, isMalKabul: false, isMuhaberat: false,
      isN11: false, isSuratkargo: false, isTrendyol: false,
      status: '1', city: '', district: '', searchText: '', isCorporational: '0'
    });
  }

  const handleSave = () => { if (campaign) updateCampaign(); else createCampaign(); }

  const getCampaignForms = () => {
    Services.GetCampaignForms(parsedUser.token, campaign.campaignID)
      .then((res) => {
        if (res.data.status) {
          setForms(res.data.result.map(f => ({ ...f, id: f.formID })));
        }
      })
      .catch((err) => console.log(err));
  }

  const isValidForm = form => form && form.title && form.formElements?.length > 0;

  const createCampaign = async () => {
    setIsLoading(true);
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState).replaceAll("&nbsp;", "");

    try {
      const res = await Services.CreateCampaign(
        parsedUser.token,
        campaignTitle,
        htmlContent,
        formattedDate(campaignStart),
        formattedDate(campaignEnd),
        extractBase64Images(campaignImages),
        campaignLink,
        getSelectedCategoriesArray(),
        false,
        ""
      );

      if (!res.data.status) { toast.error("Kampanya eklenirken bir sorun oluştu."); setIsLoading(false); return; }

      const newCampaignID = res.data.result;
      toast.success("Kampanya başarıyla eklendi.");
      getCampaigns(parsedUser.token);

      let selectedRealFormID = selectedFormId;
      const selectedFormObject = newlyAddedForms.find(f => f.id === selectedFormId);

      for (const form of newlyAddedForms) {
        const formRes = await Services.AddCampaignForm(
          parsedUser.token,
          newCampaignID,
          form.title,
          { ...form.formElements, campaignTitle: campaign?.title },
          "",
          form.legalContent
        );
        if (formRes.data.status && form.id === selectedFormObject?.id) {
          selectedRealFormID = formRes.data.result.formID;
        } else if (!formRes.data.status) {
          toast.error(`Form eklenirken hata: ${form.title}`);
        }
      }

      // Not: NOKTALAR burada CreateCampaign servisine gönderilmiyor. (Talebe göre sadece Update'te log)

      if (applyWithForm && selectedRealFormID) {
        await Services.UpdateCampaign(
          parsedUser.token,
          newCampaignID,
          campaignTitle,
          htmlContent,
          formattedDate(campaignStart),
          formattedDate(campaignEnd),
          extractBase64Images(campaignImages),
          campaignLink,
          getSelectedCategoriesArray(),
          true,
          true,
          selectedRealFormID
        );
      }

      setNewlyAddedForms([]);
      handleOnClose();
    } catch (err) {
      console.error(err);
      toast.error("Beklenmedik hata.");
    } finally {
      setIsLoading(false);
    }
  };

  const updateCampaign = async () => {
    setIsLoading(true);
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState).replaceAll("&nbsp;", "");

    try {
      let selectedRealFormID = selectedFormId;
      const selectedFormObject = newlyAddedForms.find(f => f.id === selectedFormId);

      for (const form of newlyAddedForms) {
        const isExistingForm = !!form.formID;
        if (isExistingForm) {
          await Services.UpdateCampaignForm(
            parsedUser.token,
            campaign.campaignID,
            form.title,
            { ...form.formElements, campaignTitle: campaign.title },
            "",
            form.legalContent,
            form.formID
          );
        } else {
          const formRes = await Services.AddCampaignForm(
            parsedUser.token,
            campaign.campaignID,
            form.title,
            { ...form.formElements, campaignTitle: campaign.title },
            "",
            form.legalContent
          );
          if (formRes.data.status) {
            if (form.id === selectedFormObject?.id) selectedRealFormID = formRes.data.result.formID;
          } else {
            toast.error(`Form eklenirken hata: ${form.title}`);
          }
        }
      }

      const campaignImageData = campaignImages[0]?.file ? extractBase64Images(campaignImages) : null;

      // ——— İSTEK: Şimdilik sadece log ———
      console.log('Selected Points (NOKTALAR):', selectedPoints);

      const updateRes = await Services.UpdateCampaign(
        parsedUser.token,
        campaign.campaignID,
        campaignTitle,
        htmlContent,
        formattedDate(campaignStart),
        formattedDate(campaignEnd),
        campaignImageData,
        campaignLink,
        getSelectedCategoriesArray(),
        isActive,
        applyWithForm,
        applyWithForm ? selectedRealFormID : ""
      );

      if (updateRes.data.status) {
        toast.success("Kampanya başarıyla güncellendi.");
        getCampaigns(parsedUser.token);
        setNewlyAddedForms([]);
        handleOnClose();
      } else {
        toast.error("Kampanya güncellenirken hata oluştu.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Beklenmedik hata.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSwitchChange = () => setIsActive(!isActive);

  // ——— Render ———
  return (
    <Modal sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }} open={open}>
      <Card sx={{ padding: '25px', overflowY: 'auto', maxHeight: '95%', width: '50%' }}>
        <div style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
          {!showFormCreator ? (
            <>
              {!campaign ? (
                <Typography variant='h6'>{language.commons.labels.add_campaing}</Typography>
              ) : (
                <Typography variant='h6'>{language.commons.labels.update_campaing}</Typography>
              )}
            </>
          ) : (
            <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
              <Typography variant='h6'>Form Oluşturucu</Typography>
            </div>
          )}

          {(campaign && !showFormCreator && !isLoading) && (
            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
              <Typography>{language.commons.labels.active_statu}</Typography>
              <Switch checked={isActive} onChange={handleSwitchChange} name="isActive" color="primary" />
            </div>
          )}
        </div>

        {isLoading ? (
          <div style={{ width: 250, height: 250, marginTop: 15, marginBottom: 15, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <CircularProgress size={22} color="error" />
          </div>
        ) : (
          <>
            {showFormCreator ? (
              <FormCreator initialForm={editingForm} onCancel={() => { setShowFormCreator(false); setEditingForm(null); }} onSave={onFormSave} />
            ) : (
              <>
                <TextField fullWidth label={language.commons.column.campaign_name + '*'} name="campaignTitle" value={campaignTitle} onChange={(e) => setCampaignTitle(e.target.value)} margin="normal" />

                <Typography sx={{ mt: '10px', mb: '15px', fontWeight: 600 }}>{language.components.AddEditCampaignModal.goal}</Typography>
                <FormGroup row>
                  <FormControlLabel control={<Checkbox checked={selectedCategories.esnaf} onChange={handleCategoryChange} name="esnaf" />} label={language.commons.roles.tradesmen} />
                  <FormControlLabel control={<Checkbox checked={selectedCategories.easypoint} onChange={handleCategoryChange} name="easypoint" />} label={language.commons.easypoint} />
                  <FormControlLabel control={<Checkbox checked={selectedCategories.personalCustomers} onChange={handleCategoryChange} name="personalCustomers" />} label={language.components.AddEditCampaignModal.person_customer} />
                </FormGroup>

                {/* NOKTALAR butonu (BolPara ile birebir) */}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 10, marginBottom: 10 }}>
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: '#DC423C', fontSize: 14, height: 46, borderRadius: '5px', padding: '8px 16px', '&:hover': { backgroundColor: '#B53228' } }}
                    onClick={() => setShowPoints(true)}
                  >
                    NOKTALAR
                  </Button>
                </div>

                {/* Noktalar paneli */}
                {showPoints && (
                  <div style={{ border: '1px solid rgba(0,0,0,0.12)', borderRadius: 8, padding: 16, marginTop: 16, maxWidth: 800 }}>
                    <Typography variant="h6" gutterBottom>Noktalar Filtreleri</Typography>

                    <FormGroup row>
                      {[
                        { field: 'isEasyPoint', label: 'EasyPoint' },
                        { field: 'isEsnaf', label: 'Esnaf' },
                        { field: 'isMalKabul', label: 'Mal Kabul' },
                        { field: 'isMuhaberat', label: 'Muhaberat' },
                        { field: 'isBox', label: 'Express' },
                      ].map(opt => (
                        <FormControlLabel key={opt.field} control={<Checkbox name={opt.field} checked={pointsFilters[opt.field]} onChange={handleCheckboxChange} />} label={opt.label} />
                      ))}
                    </FormGroup>

                    <FormGroup row>
                      {[
                        { field: 'isAmazon', label: 'Amazon' },
                        { field: 'isArasKargo', label: 'Aras Kargo' },
                        { field: 'isHepsiburada', label: 'Hepsiburada' },
                        { field: 'isHepsijet', label: 'Hepsijet' },
                        { field: 'isN11', label: 'N11' },
                        { field: 'isSuratkargo', label: 'Suratkargo' },
                        { field: 'isTrendyol', label: 'Trendyol' },
                      ].map(opt => (
                        <FormControlLabel key={opt.field} control={<Checkbox name={opt.field} checked={pointsFilters[opt.field]} onChange={handleCheckboxChange} />} label={opt.label} />
                      ))}
                    </FormGroup>

                    <FormControl component="fieldset" sx={{ mt: 2 }}>
                      <FormLabel component="legend">Kurumsal/Bireysel</FormLabel>
                      <RadioGroup row name="isCorporational" value={pointsFilters.isCorporational} onChange={handleCorporationalChange}>
                        <FormControlLabel value="1" control={<Radio />} label="Kurumsal" />
                        <FormControlLabel value="0" control={<Radio />} label="Bireysel" />
                      </RadioGroup>
                    </FormControl>

                    <FormControl component="fieldset" sx={{ mt: 2 }}>
                      <FormLabel component="legend">Durum</FormLabel>
                      <RadioGroup row name="status" value={pointsFilters.status} onChange={handleRadioChange}>
                        <FormControlLabel value="1" control={<Radio />} label="Aktif" />
                        <FormControlLabel value="0" control={<Radio />} label="Pasif" />
                      </RadioGroup>
                    </FormControl>

                    <TextField select label="İl" value={pointsFilters.city} onChange={handleCityChange} fullWidth sx={{ mt: 2 }}>
                      {cities.map(c => (<MenuItem key={c.code} value={c.code}>{c.name}</MenuItem>))}
                    </TextField>

                    <TextField select label="İlçe" value={pointsFilters.district} onChange={handleDistrictChange} fullWidth sx={{ mt: 2 }} disabled={!pointsFilters.city}>
                      {districts.map(d => (<MenuItem key={d.code} value={d.code}>{d.name}</MenuItem>))}
                    </TextField>

                    <TextField label="Ara" variant="outlined" size="small" fullWidth value={pointsFilters.searchText} onChange={handleSearchChange} sx={{ mt: 2, mb: 2 }} />

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                      <Button variant="contained" sx={{ mt: '15px' }} onClick={() => { setSelectedPoints([]); applyFilters(allPoints); setPage(0); }}>Filtrele</Button>
                    </div>

                    {pointsData.length > 0 && (
                      <>
                        <TableContainer component={Paper} sx={{ mt: 2 }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    indeterminate={selectedPoints.length > 0 && selectedPoints.length < pointsData.length}
                                    checked={pointsData.length > 0 && selectedPoints.length === pointsData.length}
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                  />
                                </TableCell>
                                <TableCell><b>Başlık</b></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {pointsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(point => (
                                <TableRow key={point.id}>
                                  <TableCell padding="checkbox">
                                    <Checkbox checked={selectedPoints.includes(point.id)} onChange={() => handleSelectPoint(point.id)} />
                                  </TableCell>
                                  <TableCell>{point.title}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <TablePagination
                          component="div"
                          count={pointsData.length}
                          page={page}
                          onPageChange={(e, newPage) => setPage(newPage)}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          labelRowsPerPage="Satır / sayfa"
                        />
                      </>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                      <Button onClick={() => {
                        setShowPoints(false);
                        // Edit modunda geri dönüyorsak mevcut seçimleri koru
                      }}>Vazgeç</Button>
                      <Button variant="contained" onClick={() => {
                        setShowPoints(false);
                        setPointsFilters({
                          isAmazon: false, isArasKargo: false, isEasyPoint: true, isEsnaf: true,
                          isHepsiburada: false, isHepsijet: false, isMalKabul: false, isMuhaberat: false,
                          isN11: false, isSuratkargo: false, isTrendyol: false,
                          status: '1', city: '', district: '', searchText: '', isCorporational: '0'
                        });
                      }}>Uygula</Button>
                    </div>
                  </div>
                )}

                <div style={{ maxWidth: '1000px', border: '1px solid rgba(145, 158, 171, 0.24)', padding: '15px', borderRadius: '8px' }}>
                  <Editor
                    editorClassName='editor'
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    toolbar={{ options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'] }}
                  />
                </div>

                <TextField fullWidth label={language.commons.labels.campaign_link} name="campaignTitle" value={campaignLink} onChange={(e) => setCampaignLink(e.target.value)} margin="normal" />

                <FormControlLabel control={<Switch checked={applyWithForm} onChange={handleSwitchApply} />} label="Form ile başvuru yapılacak" />
                {applyWithForm && !showFormCreator && (
                  <Box mb={2}>
                    <div style={{ display: 'flex' }}>
                      <Select fullWidth value={selectedFormId} displayEmpty onChange={e => setSelectedFormId(e.target.value)} renderValue={val => val ? forms.find(f => f.id === val)?.title : 'Form seçin'} sx={{ mb: 1 }}>
                        {forms.map(form => (
                          <MenuItem key={form.id} value={form.id}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                              <Typography noWrap>{form.title}</Typography>
                              <Box>
                                <IconButton size="small" onClick={() => { setEditingForm(form); setShowFormCreator(true); }}><Edit fontSize="small" /></IconButton>
                                <IconButton size="small" onClick={() => handleFormDelete(form.formID)}><GridDeleteIcon fontSize="small" /></IconButton>
                                <IconButton size="small" onClick={() => setPreviewForm(form)}><VisibilityIcon fontSize="small" /></IconButton>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </div>

                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                      <CompleteButton onClick={() => setShowFormCreator(true)} label={' Yeni Form Oluştur'} />
                    </div>
                  </Box>
                )}

                <Modal open={!!previewForm} onClose={() => setPreviewForm(null)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                  <Card sx={{ p: 3, width: 400 }}>
                    <Typography variant="h6" gutterBottom>Önizleme: {previewForm?.title}</Typography>
                    {previewForm?.formElements.map(q => (
                      <Box key={q.id} mb={2}>
                        <Typography>{q.label}</Typography>
                        {q.type === 'short' && <TextField fullWidth disabled />}
                        {q.type === 'long' && <TextField fullWidth multiline rows={3} disabled />}
                        {q.type === 'multiselect' && q.options.map(opt => (<FormControlLabel key={opt} control={<Checkbox disabled />} label={opt} />))}
                        {q.type === 'single' && (
                          <RadioGroup>{q.options.map(opt => (<FormControlLabel key={opt} control={<Radio disabled />} label={opt} />))}</RadioGroup>
                        )}
                        {q.type === 'yesno' && (<FormControlLabel control={<Switch disabled />} label={`${q.labels.yesLabel} / ${q.labels.noLabel}`} />)}
                        {q.type === 'dropdown' && (
                          <FormControl fullWidth><Select disabled>{q.options.map(opt => (<MenuItem key={opt} value={opt}>{opt}</MenuItem>))}</Select></FormControl>
                        )}
                        {q.type === 'citydistrict' && (
                          <Box display="flex" gap={2}>
                            <FormControl fullWidth><Select disabled displayEmpty value=""><MenuItem value="" disabled>İl Seçin</MenuItem></Select></FormControl>
                            <FormControl fullWidth disabled><Select disabled displayEmpty value=""><MenuItem value="" disabled>İlçe Seçin</MenuItem></Select></FormControl>
                          </Box>
                        )}
                      </Box>
                    ))}
                    <CompleteButton onClick={() => setPreviewForm(null)} label="Kapat" />
                  </Card>
                </Modal>

                <Typography sx={{ mt: '10px', mb: '15px', fontWeight: 600 }}>{language.commons.labels.campaign_img}</Typography>
                <div style={{ width: '100%' }}>
                  <MultipleImageUpload setFiles={setCampaignImages} files={campaignImages} />
                </div>

                <div style={{ width: '100%', marginTop: '15px', justifyContent: 'space-between', display: 'flex' }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker sx={{ mr: '8px', width: '50%' }} format="DD/MM/YYYY" label={language.commons.labels.start_date} value={campaignStart} onChange={(newValue) => { setCampaignStart(newValue); setCampaignEnd(null); }} />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker sx={{ width: '50%' }} format="DD/MM/YYYY" label={language.commons.labels.end_date} value={campaignEnd} minDate={campaignStart} disabled={!campaignStart} onChange={(newValue) => setCampaignEnd(newValue)} />
                  </LocalizationProvider>
                </div>

                <div style={{ width: '100%', alignItems: 'center', justifyContent: 'flex-end', gap: '15px', display: 'flex', marginTop: '15px' }}>
                  <CancelButton onClick={handleOnClose} label={language.commons.give_up} />
                  <CompleteButton disabled={!allFieldsAreValid()} onClick={handleSave} label={language.commons.save} />
                </div>
              </>
            )}
          </>
        )}
      </Card>
    </Modal>
  );
}